<template>
  <div class="basecheckgroup">
    <label>{{ labelText }}</label>
    <b-form-checkbox-group
      :checked="checked"
      @change="$emit('change', $event)"
      :options="options"
      :disabled="disabled"
    ></b-form-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'BaseCheck',
  props: {
    labelText: {
      type: String,
      default: ''
    },
    checked: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.basecheckgroup {
  display: flex;
  align-items: center;
  label {
    flex: 0 0 80px;
    margin-bottom: 0;
  }
}

.widerlabel {
  label {
    flex: 0 0 100px;
  }
}
</style>
